import React, { useState } from "react";
import { useLocation } from 'react-router-dom';

import './Layout.css';

import TopBar from '../topbar/TopBar';
import Main from "../main/Main";
import AboutMe from '../AboutMe/AboutMe';
import Bookmark from '../bookmark/Bookmark';
import Recipe from '../recipe/Recipe';
import Til from '../til/Til';
import App from '../app/App';
import Section from '../common/Section';
import Egg from '../egg/Egg';

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const isContextSwitcher = location.pathname === '/apps/context-switcher';

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClick = (e) => {
    // Close sidebar on mobile when clicking a link
    if (e.target.tagName === 'A' || e.target.closest('a')) {
      setIsSidebarOpen(false);
    }
  };

  if (isContextSwitcher) {
    return (
      <div className="layout layout-fullscreen">
        <Main/>
      </div>
    );
  }

  return (
    <div className="layout">
      <TopBar name="mutantbutton2" onMenuToggle={toggleSidebar} showMenu={true}/>
      <div className="layout-container">
        <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`} onClick={handleSidebarClick}>
          <AboutMe />
          <Section title="[ BLOGS ]" link="/blogs" contentClassName="blog-content">
          </Section>
          <Recipe />
          <Til />
          <Bookmark />
          <App />
        </div>
        <div className="main-content">
          <Main/>
        </div>
      </div>
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
      <Egg />
    </div>
  );
}

export default Layout;
